
import { TableBody, Table } from "@/components/ui/table";
import { ProgramTableHeader } from "./ProgramTableHeader";
import { ProgramRow } from "./ProgramRow";
import type { Program } from "@/types/program";

interface ProgramTableProps {
  programs: Program[];
  selectedPrograms: string[];
  toggleProgramSelection: (id: string, e: React.MouseEvent<Element, MouseEvent>) => void;
  toggleSelectAll: () => void;
  onProgramClick: (id: string) => void;
}

export function ProgramTable({
  programs,
  selectedPrograms,
  toggleProgramSelection,
  toggleSelectAll,
  onProgramClick
}: ProgramTableProps) {
  const allSelected = programs.length > 0 && selectedPrograms.length === programs.length;
  
  return (
    <Table>
      <ProgramTableHeader 
        allSelected={allSelected} 
        hasPrograms={programs.length > 0}
        onToggleSelectAll={toggleSelectAll} 
      />
      <TableBody>
        {programs.map((program) => (
          <ProgramRow 
            key={program.id}
            program={program}
            selected={selectedPrograms.includes(program.id)}
            onSelect={toggleProgramSelection}
            onClick={onProgramClick}
          />
        ))}
      </TableBody>
    </Table>
  );
}
